import httpClient from './httpClient';

const API_PREFIX = "admaster/v1";

export default {
  getAdvertiser(advertiserCrn) {
    return httpClient.get(`${API_PREFIX}/advertisers/${advertiserCrn}`);
  },
  getApps(advertiserCrn) {
    return httpClient.get(`${API_PREFIX}/advertisers/${advertiserCrn}/apps`);
  },
  getAdAccount(adAccountId) {
    return httpClient.get(`${API_PREFIX}/ad-accounts/${adAccountId}`)
  },
  findAllAdAccounts() {
    return httpClient.get(`${API_PREFIX}/ad-accounts`)
  },
  getAdAccountsByUserId(userId) {
    return httpClient.get(`${API_PREFIX}/admin-users/${userId}/ad-accounts`)
  },
  getCampaigns(adAccountId) {
    return httpClient.get(`${API_PREFIX}/ad-accounts/${adAccountId}/campaigns`);
  },
  getCampaign(campaignId, adAccountId) {
    return httpClient.get(`${API_PREFIX}/campaigns/${campaignId}?ad-account-id=${adAccountId}`);
  },
  postCampaign(createCampaignRequestBody) {
    return httpClient.post(`${API_PREFIX}/campaigns`, createCampaignRequestBody);
  },
  getAgencies() {
    return httpClient.get(`${API_PREFIX}/agencies`);
  },
  getAdAccountsByAgencyCrn(agencyCrn) {
    return httpClient.get(`${API_PREFIX}/agencies/${agencyCrn}/ad-accounts`)
  }
}
